import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the ObjectFiltersProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class FiltersServiceProvider {

  public listCollection: Object = {};

  constructor(public http: HttpClient) {
    // console.log('Hello ObjectFiltersProvider Provider');
  }

  public extractObjectValuesAsColonSeparatedStrings(obj)
  {
    let result ="";
    let keys = Object.keys(obj);
    for(let i=0; i<keys.length; i++){
      
      if(keys[i]=="_id") continue;
      if(keys[i]=="shortid") continue;
      if(keys[i]=="creationTime") continue;
      if(keys[i]=="__v") continue;
      if(keys[i]=="identificationToken") continue;
      if(keys[i]=="authenticationToken") continue;
      if(keys[i]=="author") continue;
      if(keys[i]=="id") continue;


      let val =obj[keys[i]];
      // console.log("doing ",keys[i],":",obj[keys[i]]);
    
      if(val)
      if(typeof val==="string") 
        result += val + ";";
      else if(typeof val==="number")
        result += val + ";";
      else if(typeof val==="object")
      {
        let newString =  this.extractObjectValuesAsColonSeparatedStrings(val);
        result += newString;
      }

    }
    // console.log("input:", obj, "result:", result);
    return result;
  }

  public prepareObjectList(objectList, listName){
    console.log("preparingObjectList")
    let stringCollection = "";
    this.listCollection[listName]= [];

    for(let i=0; i<objectList.length; i++){
      this.listCollection[listName].push(this.extractObjectValuesAsColonSeparatedStrings(objectList[i]));    
    }
  }

  public filterObjectArray(searchTerm, objectList, listName)
  {
    if(!this.listCollection[listName]) this.prepareObjectList(objectList, listName);

    let result =[];
    this.listCollection[listName].forEach((item,index) =>{
      if(item.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1){
        console.log("got it!", index)
        result.push(objectList[index]);
      }
    });
    return result;
  }

}



// WEBPACK FOOTER //
// ./src/providers/filters.service.ts